import * as t from "io-ts";

export const CampaignEvent = t.union([
  t.literal("page_viewed"),
  t.literal("user_signed_up"),
  t.literal("account_registered"),
  t.literal("account_subscribed"),
]);

export type CampaignEvent =
  | "page_viewed"
  | "user_signed_up"
  | "account_registered"
  | "account_subscribed";
